import { faChevronRight, faHome } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { NavLink, useLocation } from "react-router-dom"
import useBreadcrumbs from "use-react-router-breadcrumbs"

function Breadcrumbs() {
  const breadcrumbs = useBreadcrumbs([{ path: "/", breadcrumb: "" }] as any)
  const { pathname } = useLocation()

  return (
    <div className="d-flex pb-2">
      {breadcrumbs.map(({ match, breadcrumb }, index: number) => {
        const isCurrent = match.pathname === pathname
        const shouldDisable =
          index === 1 ||
          isCurrent ||
          match.pathname.endsWith("/preview") ||
          match.pathname.endsWith("/edit") ||
          match.pathname.endsWith("/details")

        return (
          <span key={match.pathname} className="fs-14 d-flex">
            <NavLink
              to={shouldDisable ? "#" : match.pathname}
              onClick={event => {
                if (shouldDisable) event.preventDefault()
              }}
              className={`${isCurrent || shouldDisable ? "blue-color cursor-default" : "font-color"}`}
              style={{
                fontWeight: `${isCurrent ? "600" : "400"}`,
              }}
            >
              <FontAwesomeIcon
                className={index === 0 ? "blue-color" : "font-color"}
                icon={index === 0 ? faHome : faChevronRight}
                style={{
                  margin: index === 0 ? "1px 6px 1px 0" : "1px 6px",
                  fontSize: index === 0 ? "0.7rem" : "0.6rem",
                }}
              />
              {breadcrumb}
            </NavLink>
          </span>
        )
      })}
    </div>
  )
}

export default Breadcrumbs
